import { render, staticRenderFns } from "./allCollectes.vue?vue&type=template&id=006a51f8&scoped=true"
import script from "./allCollectes.vue?vue&type=script&lang=js"
export * from "./allCollectes.vue?vue&type=script&lang=js"
import style0 from "./allCollectes.vue?vue&type=style&index=0&id=006a51f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006a51f8",
  null
  
)

export default component.exports